<template>
  <div class="welfare-content">
    <div class="nav-wrap">
      <StatusView />
      <div class="navbox">
        <img class="left" src="@/assets/nav/yz_nav_fh.png" alt="" @click="goBack" />
        <div class="title">兑换记录</div>
      </div>
    </div>

    <div class="content">
      <StatusView />
      <div class="navbox"></div>
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, i) in state.getLists"
          :key="item.id || i + '-list'"
          :border="false"
        >
          <template #value>
            <div class="record-card">
              <div class="record-main">
                <img class="game-icon" :src="item.game_icon" alt="" />
                <div class="record-info">
                  <div class="game-name">{{ item.gamename }}</div>
                  <div class="prop-name">{{ item.prop_name }}</div>
                </div>
                <div class="gold-box">
                  <span>{{ item.need_gold }}</span>
                  <em>金币</em>
                </div>
              </div>
              <div class="record-code" @click="copyCode('.record-code',item.card_code)">
                <span>兑换码</span>
                <strong>{{ item.card_code }}</strong>
                <i class="copy-icon"></i>
              </div>
              <div class="record-time">兑换时间：{{ item.create_time }}</div>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>


  </div>
</template>
<script setup>
import "animate.css";
import { ref, onMounted, reactive, nextTick, onActivated } from "vue";
import "swiper/swiper-bundle.min.js";
import "swiper/modules/effect-creative/effect-creative.min.css";
import { setToken } from "@/utils/auth";
// 领券
import { getQueryString } from "../../utils/location";
import StatusView from "../public/StatusView.vue";
import { welfareTreasureUserList } from "../../api/welfare";
import router from "../../router";
import { Toast } from "vant";
import { handleCopy } from "../../utils/tool";
const state = reactive({
  username: "",
  uid: "",
  getLists: [],
  loading: false,
  finished: false,


});

var pagecode = 0;
const onLoad = () => {
  pagecode++;
  getMoneylog();
};

const getMoneylog = async () => {
  try {
    let res = await welfareTreasureUserList({
      uid: getQueryString("uid"),
      pagecode: pagecode,
    });
    if (res.data.code == 1) {
      const lists = res.data.lists || [];
      if(pagecode == 1){
        state.getLists = lists;
      }else{
        state.getLists = state.getLists.concat(lists);
      }
      
      if (pagecode >= res.data.total_page) {
        state.finished = true;
      }
    } else {
      Toast(res.data.msg);
      state.finished = true;
    }
    state.loading = false;
  } catch (error) {
    console.log(error);
    state.loading = false;
    state.finished = true;
  }
};

onActivated(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  state.uid = getQueryString("uid");
  state.username = getQueryString("username");

  pagecode = 0
  state.getLists = []
  state.loading = false
  state.finished = false
  onLoad()
});


const goBack = ()=>{
  router.go(-1)
}

const copyCode = (id,code)=>{
  handleCopy(id,code)
}



</script>


<style scoped>

.nav-wrap {
  background: rgba(255, 255, 255,1);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100%;
}
.navbox {
  position: relative;
  width: 100%;
  height: 90px;
}

.navbox .left {
  width: 70px;
  height: 70px;
  padding: 10px;
  position: absolute;
  left: 22px;
  top: 50%;
  transform: translateY(-50%);
}

.navbox .title {
  font-size: 30px;
  font-weight: 600;
  color: #333;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.welfare-content {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: #f7f8f9;
}

.gift-box {
  flex: 1;
  background: linear-gradient(180deg, #e8faff, #eaf3f5);
  border: 2px solid #FFFFFF;
  border-radius:  60px 60px 0px 0px;
  margin-top: 20px;
  overflow: scroll;
  padding-top: 40px;
}

:deep(.van-search){
  padding: 2px 32px !important;
}

:deep(.van-search .van-search__content) {
  background-color: white;
  border-radius: 38px;
  border: 2px solid #D9D9D9;
  line-height: 76px;
  color: #333;
}

:deep(.van-search input::placeholder) {
  color: #666;
}

.search {
  height: 76px;
  background-color: white;
  border-radius: 38px;
  border: 2px solid #D9D9D9;
  line-height: 76px;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 32px;
  margin-right: 32px;
}


.content {
  padding: 0 32px;
  padding-top: 24px;
  overflow: auto;
}
.van-cell {
  background: transparent;
  display: block;
  padding: 0;
  margin-bottom: 20px;
}

:deep(.van-cell__value) {
  overflow: visible;
}

.record-card {
  background: #fff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(42, 69, 53, 0.08);
}

.record-main {
  display: flex;
  align-items: center;
}

.game-icon {
  width: 96px;
  height: 96px;
  border-radius: 18px;
  object-fit: cover;
  flex-shrink: 0;
  background: #EEF3EC;
}

.record-info {
  min-width: 0;
  flex: 1;
  padding: 0 20px;
}

.game-name {
  font-size: 30px;
  line-height: 38px;
  color: #222;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prop-name {
  margin-top: 8px;
  font-size: 26px;
  line-height: 34px;
  color: #3C8F5A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prop-num {
  margin-top: 6px;
  font-size: 22px;
  line-height: 30px;
  color: #8B9489;
}

.gold-box {
  width: 92px;
  height: 92px;
  border-radius: 16px;
  background: #FFF5DF;
  color: #E78A18;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.gold-box span {
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;
}

.gold-box em {
  margin-top: 2px;
  font-size: 20px;
  line-height: 24px;
  font-style: normal;
}

.record-code {
  margin-top: 22px;
  min-height: 64px;
  border-radius: 12px;
  background: #F6F8F5;
  display: flex;
  align-items: center;
  padding: 0 18px;
  cursor: pointer;
}

.record-code span {
  width: 72px;
  font-size: 22px;
  color: #8B9489;
  flex-shrink: 0;
}

.record-code strong {
  min-width: 0;
  flex: 1;
  font-size: 26px;
  color: #333;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.copy-icon {
  position: relative;
  width: 28px;
  height: 28px;
  margin-left: 12px;
  flex-shrink: 0;
}

.copy-icon::before,
.copy-icon::after {
  content: "";
  position: absolute;
  width: 18px;
  height: 20px;
  border: 2px solid #AEB5AD;
  border-radius: 4px;
  background: #F6F8F5;
}

.copy-icon::before {
  top: 6px;
  left: 3px;
}

.copy-icon::after {
  top: 2px;
  left: 8px;
}

.record-time {
  margin-top: 14px;
  font-size: 24px;
  line-height: 32px;
  color: #8B9489;
  text-align: right;
}

</style>
